import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppBBWaardecheckReportNewCondition = (): DescribeNodeType =>
  'een nieuwe brainbay waardecheck is opgevraagd';

export default describeAppBBWaardecheckReportNewCondition;
